/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
 import styled from "@mui/styled-engine-sc";
 import { dimensions } from "../../../themes";
 import AccountCircleIcon from "@mui/icons-material/AccountCircle";

 const headerHeight = dimensions.header.height.desktop;
 const mobileHeaderHeight = dimensions.header.height.mobile;
 
 export const StyledHeaderIcon = styled(AccountCircleIcon)`
   ${({ theme }) => `
     color: ${theme.palette.text.secondary};
     vertical-align: middle;
 
     &:hover {
       color: ${theme.palette.primary.main};
     }
   `}
 `;
 
 const StyledHeader = styled("header")`
   ${({ theme }) => `
   background-color: ${theme.palette.background.paper};
   border-bottom: solid ${theme.palette.primary.main} 1px;
   box-shadow: none !important;
   z-index: 20;
   
 
   .header-topbarSection {
     height: ${headerHeight}px;
     width: auto;
 
     ${theme.breakpoints.down("md")} {
      height: ${mobileHeaderHeight}px;
      width: auto;
     }
   }
 
   .welcome-text {
     .MuiTypography-button {
       color: ${theme.palette.text.primary};
     }
 
     .MuiTypography-root {
       line-height: 1.5;
     }
   }
 
 
   .menu-container {
     display: none;
 
     &.open {
       position: relative;
       display: flex;
     }
   }
 
   .expanded-menu-container{
     background-color: ${theme.palette.primary.main};
     line-height: normal;
     position: relative;
     color: ${theme.palette.text.expandedMenu};
     text-align: left;
     z-index: -1;
     &.hover {
       .MuiBox-root {
         background-color:${theme.palette.background.paper};
       }
     }
   }
 
   .MuiTypography-body2 {
     display: inline-block;
   }
 
   #signin_link,
   #myaccount_link,
   #cart_link {
     color: ${theme.palette.text.primary};
     text-decoration: none;
 
     &:visited {
       color: ${theme.palette.text.primary};
     }
 
     &:hover {
       color: ${theme.palette.primary.main};
 
       .MuiSvgIcon-root {
         color: ${theme.palette.primary.main};
       }
     }
 
     .MuiSvgIcon-root {
       color: ${theme.palette.text.primary};
       vertical-align: middle;
       font-size: 1.3rem;
     }
   }
 
   .menu-container {
     position: absolute;
     z-index: 3;
     background: white;
     margin: 0;
     left: 0;
     border-top: 1px solid ${theme.palette.action.disabledBackground};
     top: ${headerHeight}px;
 
     ${theme.breakpoints.down("md")} {
       top: ${mobileHeaderHeight}px;
       width: 500px;
     }
   }
 
    .header-menu {
      .MuiDrawer-paperAnchorTop {
        padding: 0px;
        margin-top: ${headerHeight}px;
      }

      .MuiDrawer-paperAnchorLeft {
        padding: 0px;
        margin-top: ${headerHeight}px;
      }

    }

   `}
 `;

 /* 
 .header-actionsButton {
     padding: ${theme.spacing(1)};
 
     &.header-actionsButton-languageToggle .MuiTypography-body1 {
       line-height: 26px;
     }
   }
  */
 export { StyledHeader };
 